module.exports = __webpack_public_path__ + "img/logoFooter.c3535dc2.png";